module.exports = __webpack_public_path__ + "static/mision-thumb-5071a27b9cb3e5a45a88124141328e47.jpg";